export default "__VITE_ASSET__CdzVXut8__"